import theme from 'config/theme';

export default {
  textfield: {
    width: '100%',
    borderRadius: '4px',
    boxShadow: 'none',
    height: '40px',

    '& .MuiInputBase-input': {
      padding: '10px 12px',
      color: theme.palette.grays.gray700,
    },
    '& .MuiInputBase-root': {
      borderRadius: '4px',
      fontSize: '0.875rem',
      width: '100%',

      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.grays.gray300}`,
      },
      '&:hover': {
        backgroundColor: `${theme.palette.grays.lightestGray}`,
        '.MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          color: theme.palette.grays.gray700,
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&.Mui-focused': {
        '.MuiOutlinedInput-notchedOutline': {
          border: 1,
          borderColor: `${theme.palette.grays.gray300}`,
        },
        '& .MuiInputBase-input': {
          backgroundColor: `${theme.palette.grays.lightestGray}`,
        },
      },
      '&:has(.MuiInputBase-input:not(:placeholder-shown))': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: `${theme.palette.blues.primaryBlue500}`,
        },
        '& .MuiInputBase-input': {
          color: `${theme.palette.blues.primaryBlue500}`,
          backgroundColor: `${theme.palette.blues.lightestBlue}`,
        },
      },
    },
  },

  dateRangeContainer: {
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    '& .MuiTextField-root': {
      flex: 1,
      '& .MuiInputLabel-root': {
        color: theme.palette.grays.gray600,
        '&.Mui-focused, &.MuiInputLabel-shrink': {
          color: `${theme.palette.blues.primaryBlue500}`,
        },
      },
      '&:has(.MuiInputBase-input:not(:placeholder-shown)) .MuiInputLabel-root':
        {
          color: `${theme.palette.blues.primaryBlue500}`,
        },
    },
    '& .MuiTypography-root': {
      marginLeft: '0 !important',
      marginRight: '0 !important',
    },
    '& .MuiTextField-root:last-child': {
      marginLeft: '0 !important',
    },
  },
};
